import { useEffect, useState } from "react";
import { getBrandLogo, DEFAULT_LOGO } from "@/lib/brand";

export default function BrandLogo({ className = "h-10", style }) {
  const [src, setSrc] = useState(DEFAULT_LOGO);
  useEffect(() => { getBrandLogo().then(setSrc); }, []);
  return (
    <img
      src={src}
      alt="Freebird Nest"
      className={className}
      style={{ objectFit: "contain", ...style }}
      data-testid="brand-logo"
    />
  );
}
